import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"
import _imports_0 from '../assets/images/logos/logo.svg'


const _hoisted_1 = { class: "d-none d-md-flex ga-4 align-center" }
const _hoisted_2 = { class: "d-flex flex-column gap-1" }
const _hoisted_3 = {
  href: "https://humanetech.substack.com/",
  target: "_blank",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}
const _hoisted_4 = {
  href: "https://www.linkedin.com/company/building-humane-technology/",
  target: "_blank",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}
const _hoisted_5 = {
  href: "https://x.com/buildhumanetech",
  target: "_blank",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}
const _hoisted_6 = { class: "d-flex flex-column gap-1" }
const _hoisted_7 = {
  href: "https://luma.com/buildinghumanetech?k=c",
  target: "_blank",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}
const _hoisted_8 = {
  href: "https://github.com/buildinghumanetech/humanebench",
  target: "_blank",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}
const _hoisted_9 = {
  href: "https://go.buildinghumanetech.com/join-slack",
  target: "_blank",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}
const _hoisted_10 = {
  href: "mailto:info@buildinghumanetech.com",
  class: "text-body-2 text-grey-darken-2 d-flex align-center gap-2",
  style: {"text-decoration":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "#fff4e0",
        class: "px-6",
        flat: "",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "d-flex justify-space-between align-center py-2" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'home' }))),
                src: _imports_0,
                alt: "Building Humane Tech",
                class: "h-12 cursor-pointer hover:opacity-80 transition-opacity"
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "text-none",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'home' })))
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Home", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "text-none",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'principles' })))
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Principles", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "text-none",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'whitepaper' })))
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("Whitepaper", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "text-none",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'case-studies' })))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("Case Studies", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_menu, {
                  "offset-y": "",
                  "open-on-hover": "",
                  "close-on-content-click": true
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({
                      text: "",
                      class: "text-none"
                    }, props), {
                      default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createTextVNode(" Models ", -1)),
                        _createVNode(_component_v_icon, {
                          right: "",
                          size: "18"
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode("mdi-chevron-down", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      density: "compact",
                      class: "models-dropdown",
                      "bg-color": "#fff4e0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'models' })))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode("All Models", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navProviderGroups, (group) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: group.provider
                          }, [
                            _createVNode(_component_v_list_subheader, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(group.provider), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.models, (model) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: model.id,
                                onClick: ($event: any) => (_ctx.$router.push({ name: 'model-detail', params: { modelId: model.id } }))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(model.displayName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "text-none",
                  href: "mailto:info@buildinghumanetech.com"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("Contact", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  text: "",
                  class: "text-none",
                  href: "https://github.com/buildinghumanetech/humanebench",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      left: "",
                      size: "20"
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("mdi-github", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[23] || (_cache[23] = _createTextVNode(" Github ", -1))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_app_bar_nav_icon, {
                class: "d-md-none",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["stop"]))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.drawer) = $event)),
        app: "",
        temporary: "",
        location: "right",
        color: "#fff4e0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$router.push({ name: 'home' }); _ctx.drawer = false})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("Home", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$router.push({ name: 'principles' }); _ctx.drawer = false})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("Principles", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$router.push({ name: 'whitepaper' }); _ctx.drawer = false})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("Whitepaper", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$router.push({ name: 'case-studies' }); _ctx.drawer = false})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("Case Studies", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_group, { value: "models" }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                          _createTextVNode("Models", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$router.push({ name: 'models' }); _ctx.drawer = false}),
                    class: "pl-8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("All Models", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navProviderGroups, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: group.provider
                    }, [
                      _createVNode(_component_v_list_subheader, { class: "pl-8" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(group.provider), 1)
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.models, (model) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: model.id,
                          onClick: ($event: any) => {_ctx.$router.push({ name: 'model-detail', params: { modelId: model.id } }); _ctx.drawer = false},
                          class: "pl-12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(model.displayName), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, { href: "mailto:info@buildinghumanetech.com" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                      _createTextVNode("Contact", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                href: "https://github.com/buildinghumanetech/humanebench",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        left: "",
                        size: "20"
                      }, {
                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("mdi-github", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[32] || (_cache[32] = _createTextVNode(" Github ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, { class: "bg-[#fff4e0]" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "py-12 min-h-[70vh]" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, {
        class: "py-6 bg-[#fff4e0]",
        padless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4",
                    lg: "3",
                    class: "d-flex flex-column mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push({ name: 'home' }))),
                          src: _imports_0,
                          alt: "Building Humane Tech",
                          class: "h-12 cursor-pointer hover:opacity-80 transition-opacity mb-4"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4",
                    lg: "3",
                    class: "d-flex flex-column mb-4"
                  }, {
                    default: _withCtx(() => [
                      _cache[39] || (_cache[39] = _createElementVNode("p", { class: "mb-3 font-weight-bold text-body-2" }, "Follow us", -1)),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", _hoisted_3, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                              _createTextVNode("mdi-newspaper-variant-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[34] || (_cache[34] = _createTextVNode(" Substack ", -1))
                        ]),
                        _createElementVNode("a", _hoisted_4, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                              _createTextVNode("mdi-linkedin", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[36] || (_cache[36] = _createTextVNode(" LinkedIn ", -1))
                        ]),
                        _createElementVNode("a", _hoisted_5, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                              _createTextVNode("mdi-twitter", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[38] || (_cache[38] = _createTextVNode(" X ", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4",
                    lg: "3",
                    class: "d-flex flex-column mb-4"
                  }, {
                    default: _withCtx(() => [
                      _cache[48] || (_cache[48] = _createElementVNode("p", { class: "mb-3 font-weight-bold text-body-2" }, "Join us", -1)),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", _hoisted_7, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                              _createTextVNode("mdi-calendar", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[41] || (_cache[41] = _createTextVNode(" Event calendar ", -1))
                        ]),
                        _createElementVNode("a", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode("mdi-github", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[43] || (_cache[43] = _createTextVNode(" GitHub ", -1))
                        ]),
                        _createElementVNode("a", _hoisted_9, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                              _createTextVNode("mdi-slack", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[45] || (_cache[45] = _createTextVNode(" Slack community ", -1))
                        ]),
                        _createElementVNode("a", _hoisted_10, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "grey-darken-2"
                          }, {
                            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                              _createTextVNode("mdi-email", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[47] || (_cache[47] = _createTextVNode(" info@buildinghumanetech.com ", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4",
                    lg: "3",
                    class: "d-flex flex-column mb-4"
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createElementVNode("p", { class: "mb-3 font-weight-bold text-body-2" }, "Partner with us:", -1),
                      _createElementVNode("a", {
                        href: "mailto:erika@buildinghumanetech.com",
                        class: "text-body-2 text-grey-darken-2 mb-4 d-flex align-center gap-2",
                        style: {"text-decoration":"none"}
                      }, " erika@buildinghumanetech.com ", -1),
                      _createElementVNode("p", { class: "mb-3 font-weight-bold text-body-2" }, "Support the mission:", -1),
                      _createElementVNode("a", {
                        href: "mailto:sponsor@buildinghumanetech.com",
                        class: "text-body-2 text-grey-darken-2 mb-4 d-flex align-center gap-2",
                        style: {"text-decoration":"none"}
                      }, " sponsor@buildinghumanetech.com ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                      _createElementVNode("p", { class: "text-caption text-grey-darken-1" }, "© 2025 Building Humane Tech. All rights reserved.", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}